export default __webpack_public_path__ + "static/media/12.64baf28c.jpeg";